import { Menu } from 'lucide-react';

import { Logo, LogoIcon } from '@/components/brand/Logo';
import { chromeTokens, type Surface } from '@/components/layout/surface';
import { cn } from '@/lib/utils/cn';
import { useUIStore } from '@/stores/ui';

interface TopBarProps {
  title: string;
  surface?: Surface;
}

export function TopBar({ title, surface = 'editorial' }: TopBarProps) {
  const setMobileNavOpen = useUIStore((s) => s.setMobileNavOpen);
  const t = chromeTokens[surface].topbar;
  const marketingUrl = import.meta.env.PUBLIC_MARKETING_URL;
  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex items-center justify-between border-b px-4 py-3 backdrop-blur transition-colors md:px-6',
        t.header,
      )}
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => setMobileNavOpen(true)}
          aria-label="Open menu"
          className={cn('rounded-md p-2 md:hidden', t.menuBtn)}
        >
          <Menu className="h-5 w-5" />
        </button>
        {/* Mobile wordmark → the public front page (Spec 28 A5), aligned to the
            sidebar wordmark. */}
        <a href={marketingUrl} aria-label="ArcheTelos — public site" className="md:hidden">
          <Logo className="h-6 w-auto" />
        </a>
        <h1 className={cn('hidden font-serif text-lg md:block', t.title)}>{title}</h1>
      </div>
      {/* Top-right: the temple icon as an exit to marketing, mirroring the sidebar
          wordmark (Spec 28 A5 — two obvious exits, by design). The compact icon
          avoids a second full wordmark in the same bar. The account affordance
          lives in the sidebar footer (Spec 27), not here. */}
      <a
        href={marketingUrl}
        aria-label="ArcheTelos — public site"
        className="transition hover:opacity-80"
      >
        <LogoIcon className="h-8 w-8" />
      </a>
    </header>
  );
}
